module.exports = __webpack_public_path__ + "img/TopCreativeLeaderBillboard.f9b9ac0a.jpg";